// TSS vite/04 §"Endpoint paths". No leading slash.
//
// The event log, read for authorship. `events:read`, filtered by `task_id`,
// `tier_id` and ONE exact `kind` (equality, not a list).
export const auditPaths = {
    events: () => 'admin/events',
};
